import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    phone: '',
    name: '',
    surname: '',
    email: '',
};

const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setCustomer: (state, action) => {
            return action.payload;
        },
        removeCustomer: () => {
            return initialState;
        },
    },
});

export const { setCustomer, removeCustomer } = customerSlice.actions;
export default customerSlice.reducer;